import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {classMap} from 'lit/directives/class-map.js';

import {connect} from 'pwa-helpers';

@customElement('usp-table')
export class UspTable extends LitElement {

	static styles = css`
		.uspTableItem {
			display: flex;
			container-type: inline-size;
			justify-content: space-between;
			width: 100%;
			padding-bottom: 0;
		}
		.title {
			width: 30%;
			font: var(--font-specsheet-print-small-text);
			font-size: 1.45cqw;
			padding-top: 1cqw;
			color: #939393;
		}
		.content {
			width: 70%;
		}

	`;

	@property({type: String})
	title = false;


	render() {
		return html`
			<div class="uspTableItem">
				<div class="title">${this.title}</div>
				<div class="content">
					<slot></slot>
				</div>
			</div>
		`;
	}
}
